module.exports = __webpack_public_path__ + "static/img/header-pic1.a634db9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/header-pic1.png
// module id = OB17
// module chunks = 1